import PropTypes from 'prop-types';
import React from 'react';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {ProductsFilter} from '@utils/commonFilters/ProductsFilter';
import {ContentTypesFilter} from '@utils/commonFilters/ContentTypesFilter';
import {ContentVariantsFilter} from '@utils/commonFilters/ContentVariantsFilter';
import {HqFilter} from '@utils/commonFilters/HqFilter';
import {LlFilter} from '@utils/commonFilters/LlFilter';
import {DistributionTypesFilter} from '@utils/commonFilters/DistributionTypesFilter';
import {DeviceCategoriesFilter} from '@utils/commonFilters/DeviceCategoriesFilter';
import {CountriesFilter} from '@utils/commonFilters/CountriesFilter';
import {getBookingStatusForOfferingsDefaultValues} from '@utils/booking';
import {BookingStatusFilter} from '@utils/commonFilters/BookingStatusFilter';
import {ClientsFilter} from '@utils/commonFilters/ClientsFilter';
import {EventContentsFilter} from '@utils/commonFilters/EventContentsFilter';

export const EventsOfferingsComponent = (props) => {
    const {
            clients,
            countries,
            deviceCategories,
            distributionTypes,
            eventContents,
            products,
            eventContentTypes,
            eventContentVariants,
        } = props.data,
        filters = props.filters.EventsOfferings,
        loading = props.loading;

    return (
        <div className='eventOfferings__filters filter__controls__container'>
            <ClientsFilter
                loading={loading}
                filters={filters}
                restoreFilterValues={props.restoreFilterValues}
                options={clients}
            />
            <EventContentsFilter
                loading={loading}
                filters={filters}
                restoreFilterValues={props.restoreFilterValues}
                options={eventContents}
            />
            <ContentTypesFilter
                eventContentTypes={eventContentTypes}
                loading={loading}
                filters={filters}
                restoreFilterValues={props.restoreFilterValues}
            />
            <ContentVariantsFilter
                eventContentVariants={eventContentVariants}
                loading={loading}
                filters={filters}
                restoreFilterValues={props.restoreFilterValues}
            />
            <ProductsFilter
                loading={loading}
                products={products}
                filters={filters}
                restoreFilterValues={props.restoreFilterValues}
            />
            <DistributionTypesFilter
                distributionTypes={distributionTypes}
                loading={loading}
                filters={filters}
                restoreFilterValues={props.restoreFilterValues}
            />
            <DeviceCategoriesFilter
                deviceCategories={deviceCategories}
                loading={loading}
                filters={filters}
                restoreFilterValues={props.restoreFilterValues}
            />
            <CountriesFilter
                countries={countries}
                loading={loading}
                filters={filters}
                restoreFilterValues={props.restoreFilterValues}
            />
            <HqFilter
                loading={loading}
                filters={filters}
                restoreFilterValues={props.restoreFilterValues}
            />
            <LlFilter
                loading={loading}
                filters={filters}
                restoreFilterValues={props.restoreFilterValues}
            />
            <BookingStatusFilter
                loading={loading}
                filters={filters}
                restoreFilterValues={props.restoreFilterValues}
            />
        </div>
    );
};

EventsOfferingsComponent.propTypes = {
    data: PropTypes.shape({
        clients: PropTypes.array.isRequired,
        countries: PropTypes.array.isRequired,
        deviceCategories: PropTypes.array.isRequired,
        distributionTypes: PropTypes.array.isRequired,
        eventContents: PropTypes.array.isRequired,
        products: PropTypes.array.isRequired,
        eventContentTypes: PropTypes.array.isRequired,
        eventContentVariants: PropTypes.array.isRequired,
    }),
    filters: PropTypes.shape({
        EventsOfferings: PropTypes.object,
    }),
    loading: PropTypes.bool.isRequired,
    restoreFilterValues: PropTypes.func,
};

EventsOfferingsComponent.defaultProps = {
    filters: {
        EventsOfferings: {},
    },
};

export default FiltersWrapper(EventsOfferingsComponent, {
    name: 'EventsOfferings',
    initialValues: {
        bookingStatus: getBookingStatusForOfferingsDefaultValues(),
    },
});
